import { Component, Input } from '@angular/core';

@Component({
    selector: 'black-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.css'],
    standalone: false,
    host: {
        ngSkipHydration: 'true',
    },
})
export class TooltipComponent {
  @Input()
  text = '';
}
